(function () {
    angular.module("harriApp")
        .factory('ShiftTemplateUtils', [function () {
            var DAY = 24 * 60 * 60;
            var MILLISECOND = 1000;

            var ShiftTemplateUtils = {
                'getTimeBreaksObj': function (intervals, fromMillis) {
                    var factor = fromMillis? 1000: 1;
                    var timeBreaksObj = {breaks: []};

                    timeBreaksObj['start_time'] = parseInt(intervals[0].start_time / factor);
                    timeBreaksObj['end_time'] = parseInt(intervals[intervals.length - 1].end_time / factor);

                    var actualEndTime = timeBreaksObj['end_time'];

                    if (timeBreaksObj['end_time'] < timeBreaksObj['start_time']) {
                        actualEndTime += 24 * 3600;
                    }

                    timeBreaksObj['duration'] = actualEndTime - timeBreaksObj['start_time'];

                    for (var i = 1; i < intervals.length; i++) {
                        var startTime = parseInt(intervals[i - 1].end_time / factor);
                        var endTime = parseInt(intervals[i].start_time / factor);

                        timeBreaksObj['breaks'].push({
                            'start_time': startTime,
                            'end_time': endTime,
                            'duration': endTime - startTime,
                            'type': 'SPLIT_SHIFT'
                        });
                    }

                    return timeBreaksObj;
                },
                'getIntervalsFromTimeAndBreaks': function (timeBreaksObj) {
                    var startTime = ShiftTemplateUtils.timeObjToSeconds(timeBreaksObj['start_time']).hours +
                        ShiftTemplateUtils.timeObjToSeconds(timeBreaksObj['start_time']).minutes;
                    var endTime = ShiftTemplateUtils.timeObjToSeconds(timeBreaksObj['end_time']).hours +
                        ShiftTemplateUtils.timeObjToSeconds(timeBreaksObj['end_time']).minutes;

                    var intervals = [{'start_time': startTime }];

                    for (var i in timeBreaksObj['breaks']) {
                        var breakObj = timeBreaksObj['breaks'][i];

                        if (breakObj.type === 'SPLIT_SHIFT') {
                            intervals[intervals.length - 1]['end_time'] = breakObj['start_time'];
                            intervals.push({'start_time': breakObj['end_time']});
                        }
                    }

                    intervals[intervals.length - 1]['end_time'] = endTime;
                    return intervals;
                },
                'timeObjToSeconds': function (date) {
                    var dateObj = new Date(date);

                    return {
                        hours: dateObj.getHours() * 60 * 60,
                        minutes: dateObj.getMinutes() * 60
                    }
                },
                'secondsToTimeObj': function (seconds) {
                    return {
                        hours: parseInt(seconds / 3600),
                        minutes: parseInt((seconds % 3600) / 60)
                    }
                },
                'timeToHours': (time) => {
                    const [hours, minutes] = time.split(':').map(Number);
                    return (hours + (minutes / 60));
                },
                'getPeriod': function (start, end, dateString) {
                    dateString = dateString || 0;
                    
                    if (end === undefined || end === null) {
                        end = start;
                    }

                    var startDate = new Date(dateString);
                    startDate.setHours(ShiftTemplateUtils.secondsToTimeObj(start).hours);
                    startDate.setMinutes(ShiftTemplateUtils.secondsToTimeObj(start).minutes);

                    var endDate = new Date(dateString);
                    endDate.setHours(ShiftTemplateUtils.secondsToTimeObj(end).hours);
                    endDate.setMinutes(ShiftTemplateUtils.secondsToTimeObj(end).minutes);

                    if (end <= start && start !== end) {
                        endDate.setDate(endDate.getDate() + 1);
                    }

                    return {
                        start: startDate,
                        end: endDate
                    }
                },
                'getIntervalsTotalTime': function (intervals, openTime) {
                    var total = 0;
                    var openTimeInMinutes = openTime / 1000 / 60;

                    for (var i in intervals) {
                        var interval = intervals[i];

                        // start and end time iso string
                        if (interval.start_time && interval.end_time) {
                            var startTime = (moment(interval.start_time).hours() * 60) + moment(interval.start_time).minutes();
                            var endTime = (moment(interval.end_time).hours() * 60) + moment(interval.end_time).minutes();

                            if (startTime < openTimeInMinutes) {
                                startTime += 24 * 60;
                            }

                            if (endTime <= startTime) {
                                endTime += 24 * 60;
                            }

                            total += (endTime - startTime);
                        }
                    }

                    // total time in minutes
                    return total;
                },
                'checkIfPeriodDatesOverlap': (period1, period2) => {
                    return (
                        period1.start_date.isSame(period2.start_date) ||
                        period1.end_date.isSame(period2.end_date) ||
                        (period1.start_date.isAfter(period2.start_date) && period1.start_date.isBefore(period2.end_date)) ||
                        (period1.start_date.isBefore(period2.start_date) && period2.start_date.isBefore(period1.end_date))
                    )
                },
                'getShiftDuration': function (intervals) {
                    var duration = 0;

                    if (intervals && intervals.length) {
                        var durationInSeconds = ShiftTemplateUtils.getShiftDurationInSeconds(intervals);
                        duration += parseFloat((durationInSeconds / 3600).toFixed(2));
                    }

                    return duration;
                },
                'getShiftDurationInSeconds': function (intervals) {
                    var duration = 0;

                    for (var inr in intervals) {
                        if (intervals[inr].start_time && intervals[inr].end_time) {
                            var startTime = (moment(intervals[inr].start_time).hours() * 60 * 60) +
                                moment(intervals[inr].start_time).minutes() * 60;

                            var endTime = (moment(intervals[inr].end_time).hours() * 60 * 60) +
                                moment(intervals[inr].end_time).minutes() * 60;

                            if (endTime <= startTime) {
                                endTime += 24 * 60 * 60;
                            }

                            duration += (endTime - startTime);
                        }
                    }

                    return duration;
                },
                'isWithinShiftTime': function (shiftIntervals, Interval) {
                    var isWithinShiftTime = false;
                    var IntervalObject = ShiftTemplateUtils.getIntervalTime(shiftIntervals[0]["start_time"], Interval);

                    for (var i in shiftIntervals) {
                        var interval = shiftIntervals[i];

                        if (IntervalObject.start_time >= interval['start_time'] && IntervalObject.end_time <= interval['end_time']) {
                            isWithinShiftTime = true;
                            break;
                        }
                    }

                    return isWithinShiftTime;
                },
                'getIntervalTime': (shiftStartTime, interval, correctFor24HoursDifference) => {
                    var startTime = (ShiftTemplateUtils.timeObjToSeconds(interval.start_time).hours + ShiftTemplateUtils.timeObjToSeconds(interval.start_time).minutes) * MILLISECOND;
                    var endTime = (ShiftTemplateUtils.timeObjToSeconds(interval.end_time).hours + ShiftTemplateUtils.timeObjToSeconds(interval.end_time).minutes) * MILLISECOND;

                    if (correctFor24HoursDifference) {
                        const start = moment(interval.start_time).valueOf();
                        const end = moment(interval.end_time).valueOf();
                        const difference = end - start;
                        if (difference >= (DAY * MILLISECOND)) {
                            endTime += DAY * MILLISECOND;
                        }
                    }

                    if (startTime < shiftStartTime) {
                        startTime += DAY * MILLISECOND;
                    }

                    if (endTime <= startTime) {
                        endTime += DAY * MILLISECOND;

                        if (endTime <= startTime) {
                            endTime += DAY * MILLISECOND;
                        }
                    }

                    return {
                        start_time: startTime,
                        end_time: endTime
                    };
                },
                'normalizeIntervalsWithShiftTime': function (shiftStartTime, intervals) {
                    var normalizedIntervals = [];

                    for (var i in intervals) {
                        var interval = angular.copy(intervals[i]);

                        if (interval.start_time) {
                            var intervalObject = ShiftTemplateUtils.getIntervalTime(shiftStartTime, interval);

                            normalizedIntervals.push({
                                start_time: intervalObject.start_time,
                                end_time: intervalObject.end_time
                            });
                        }
                    }

                    return normalizedIntervals;
                },
                'formatTemplateJobTitlesTimes': function (jobTitles, day) {
                    var formattedTemplateJobTitlesTimes = [];
                    for (var i in jobTitles) {
                        var jobTitle = jobTitles[i];

                        if (jobTitle.start_time !== null && jobTitle.end_time !== null) {
                            var period = ShiftTemplateUtils.getPeriod(jobTitle.start_time, jobTitle.end_time, day);
                            jobTitle.start_time = period.start;
                            jobTitle.end_time = period.end;
                            formattedTemplateJobTitlesTimes.push(jobTitle);
                        }
                    }
                    return formattedTemplateJobTitlesTimes;
                },
                'isIntervalsOverlapped': function (shiftStartTime, interval, intervals) {
                    var isOverlapped = false;
                    var normalizedIntervals = ShiftTemplateUtils.normalizeIntervalsWithShiftTime(shiftStartTime, intervals);
                    var intervalObject = ShiftTemplateUtils.getIntervalTime(shiftStartTime, interval);
                    var startTime = intervalObject.start_time;
                    var endTime = intervalObject.end_time;

                    for (var i in normalizedIntervals) {
                        if (
                            startTime === normalizedIntervals[i].start_time ||
                            endTime === normalizedIntervals[i].end_time ||
                            (startTime > normalizedIntervals[i].start_time && startTime < normalizedIntervals[i].end_time) ||
                            (startTime < normalizedIntervals[i].start_time && normalizedIntervals[i].start_time < endTime)
                        ) {
                            isOverlapped = true;
                            break;
                        }
                    }

                    return isOverlapped;
                },
                'hasStationsGap': function (interval, normalizedJobTitles) {
                    var jobTitlesPerInterval = normalizedJobTitles.filter(function (jt) {
                        return jt.end_time <= interval.end_time && jt.start_time >= interval.start_time
                    });

                    if (jobTitlesPerInterval.length === 0) {
                        return true;
                    }
                    jobTitlesPerInterval.sort(function (jt1, jt2) {
                        if (jt1['start_time'] < jt2['start_time']) {
                            return -1;
                        }
                        if (jt1['start_time'] > jt2['start_time']) {
                            return 1;
                        }
                        return 0;

                    });
                        for (var index = 0 ; index < jobTitlesPerInterval.length; index++) {
                            var jt1 = jobTitlesPerInterval[index];
                            var slotStartTime = interval.start_time;
                            var slotEndTime =interval.end_time;
                            var jtStartTime = jt1.start_time;
                            var jtEndTime = jt1.end_time;

                            if (index === 0) {
                                if (jtStartTime > slotStartTime) {
                                    return true;
                                }
                            }
                            if (index === jobTitlesPerInterval.length - 1) {
                                if (jtEndTime < slotEndTime) {
                                    return true;
                                }
                            }
                            if (jobTitlesPerInterval[index-1] && jobTitlesPerInterval[index-1].end_time) {
                                var previousJtEndTime = jobTitlesPerInterval[index-1] && jobTitlesPerInterval[index-1].end_time;
                                if (jtStartTime > previousJtEndTime) {
                                    return true;
                                }
                            }

                        }
                        return false;
                }
            };

            return ShiftTemplateUtils;
        }]);
})();
